import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShare } from '@fortawesome/free-solid-svg-icons'; 
import { faShareNodes } from '@fortawesome/free-solid-svg-icons'; 
const ShareButton = ({open}) => {
  // const urltoshare= open ? `https://ukexpress.in/News/${open}` : window.location.href
  const urltoshare=`https://ukexpress.in/News/${open}`
  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: document.title,
          url:urltoshare 

        });
        console.log('Shared successfully!');
      } else {
        alert('Sharing not supported on this browser');
      }
    } catch (err) {
      console.error('Error sharing:', err);
    }
  };

  return (
    <button onClick={handleShare}>
     {/* <FontAwesomeIcon icon={faShare} className='share-icon'/> */}
     <FontAwesomeIcon icon={faShareNodes}  className='share-icon' />
    </button>
  );
};

export default ShareButton;
